import axios from "axios";
import { FiltersRequiredError, NotImplementedError, parseNewNewYorkApiResponse } from "../../../..";
import { ObservableHandler } from "../../../../handlers";
import { Observable } from "rxjs";
import { toQueryParams } from "./filters/params";
import { parseIdFilter } from "../../../../handlers/filter";
import { isServicePage } from "../../../../handlers/page";
/**
 * Converts service response to client format following FE patterns
 */
export function servicePublisherTemplateChannelToPublisherTemplateChannel(serviceChannel) {
    return {
        channelName: serviceChannel.name,
        publisherId: serviceChannel.pub_id,
        excluded: serviceChannel.excluded,
        publisherName: "" // Will be populated by frontend publisher lookup
    };
}
/**
 * Handles publisher template channel operations.
 * Channels are associated with templates and represent specific configurations or settings.
 */
class PublisherTemplateChannels extends ObservableHandler {
    constructor(sdk) {
        super(sdk, "publishers.optimizationTemplates.channels");
    }
    /**
     * Find a channel based on a template ID.
     *
     * @param filters: filter template channels by a given template ID (e.g., {where: [field: "id", type: FilterTypes.EQ, value: "1"]}).
     *          Supports (and requires):
     *              {FilterTypes.EQ, "id"}
     */
    findItems(filters) {
        const idFilter = parseIdFilter(filters);
        if (!idFilter) {
            throw new FiltersRequiredError("id");
        }
        return new Observable((subscriber) => {
            this.getTemplateChannels(filters)
                .then((channels) => {
                subscriber.next(channels);
                subscriber.complete();
            })
                .catch((error) => {
                subscriber.error(error);
            });
        });
    }
    async getTemplateChannels(filters = {}) {
        const templateId = filters.where?.find((filter) => filter.field === "id")
            ?.value;
        if (!templateId) {
            throw new FiltersRequiredError("id");
        }
        const params = toQueryParams(filters);
        const pageSize = filters?.paging?.size || 10;
        const url = `${this.sdk.urls.baseAPIUrl}/publisher-template-channel-rules/${templateId}${params}`;
        return this.cache.promise(`${url}`, () => axios
            .get(`${url}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
            const rawChannelData = parseNewNewYorkApiResponse(res);
            // Convert service response to client format
            const convertedData = rawChannelData.data.map(servicePublisherTemplateChannelToPublisherTemplateChannel);
            let results = convertedData;
            if (isServicePage(rawChannelData)) {
                results = {
                    page: {
                        count: rawChannelData.paging_info.count,
                        token: rawChannelData.paging_info.token,
                        size: pageSize
                    },
                    data: convertedData
                };
            }
            return results;
        })
            .catch((error) => {
            throw error;
        }));
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    make(channel) {
        throw new NotImplementedError("make");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    saveItem(channel) {
        throw new NotImplementedError("save");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    async deleteItem(id) {
        throw new NotImplementedError("delete");
    }
    getIdentifierKey() {
        return "name";
    }
}
export default PublisherTemplateChannels;
//# sourceMappingURL=index.js.map